import { TFunction } from 'i18next'

import { PayrollFrequency } from '../../../types/payrollFrequency'

export const frequencyToTranslation = (t: TFunction): Record<PayrollFrequency, string> => ({
  [PayrollFrequency.Monthly]: t('salary.payroll_list.table.frequency.monthly'),
  [PayrollFrequency.Weekly]: t('salary.payroll_list.table.frequency.weekly'),
  [PayrollFrequency.BiWeekly]: t('salary.payroll_list.table.frequency.biweekly'),
})
